import { render, staticRenderFns } from "./subscription-notification.vue?vue&type=template&id=2e3bf460&"
import script from "./subscription-notification.vue?vue&type=script&lang=js&"
export * from "./subscription-notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports